module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block1"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TALKING DIRTY")])])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p10"
    }
  }, [_vm._v("Once Upon a Time, I was attending a support group for survivors with post-traumatic stress disorder. We were in the basement of a Methodist church in Vista Verde, West Virginia, sitting on folding aluminum chairs, eating sticky pastries, and drinking herbal tea out of plain white ceramic cups. Justin, the soft middle-aged therapist with a gentle voice and a gray sweater, said that he wasn’t in favor of caffeine at these sorts of things. He probably wasn’t in favor of people shaking him violently and screaming “GIVE ME COFFEE RIGHT NOW, MIND-FUCKER!” either, so I just sipped the damn tea quietly.")]), _c('p', {
    attrs: {
      "id": "p11"
    }
  }, [_vm._v("Cassidy was talking at the moment, a brown-haired thirtysomething who had been severely beaten by her ex-husband, Steve, right before he disappeared. “I didn’t see the bills until after he left. Then I couldn’t stop seeing them. We were still legally married, and the credit card companies knew they weren’t going to get any money out of "), _c('i', [_vm._v("him")]), _vm._v(". He lost his job for calling some kind of sex hotline on his company’s phone, if you can believe that. He was thousands and thousands of dollars in debt, a lot of it from calling that number. It was crazy. "), _c('i', [_vm._v("He")]), _vm._v(" was crazy.”\n         ")]), _c('p', {
    attrs: {
      "id": "p12"
    }
  }, [_vm._v("Justin leaned forward, his watery blue eyes intent behind his small square glasses. “So, what I hear you saying is, you felt betrayed on multiple levels.” Justin was a bit of a tool, but his good intentions were palpable.")]), _c('p', {
    attrs: {
      "id": "p13"
    }
  }, [_vm._v("“If it had been drugs, I could have maybe understood it,” Cassidy said. “But he was paying these women…or this woman…just to talk. He had the real thing at home.” She indicated herself. She was quite pretty in a worn, tired, dark-eyed, dehydrated kind of way. “I would have loved to have had more sex!”")]), _c('p', {
    attrs: {
      "id": "p14"
    }
  }, [_vm._v("“It’s never a good idea to generalize about—” Justin started, but Cassidy wasn’t finished.")]), _c('p', {
    attrs: {
      "id": "p15"
    }
  }, [_vm._v("“I actually called the number,” she confessed. “I was almost hoping it would be a man or something.”")]), _c('p', {
    attrs: {
      "id": "p16"
    }
  }, [_vm._v("Just for the record? People only say that kind of thing when they’ve never met an "), _c('i', [_vm._v("or something")]), _vm._v(".\n         ")]), _c('p', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("“It would mean that it wasn’t something wrong with me,” Cassidy finished when no one responded.")]), _c('p', {
    attrs: {
      "id": "p18"
    }
  }, [_vm._v("“This man broke into your house and beat you half to death, and you’re still trying to figure out what was wrong with you?” This from a graying woman named Cheyenne who had been emotionally terrorized by her stepfather and was tired of failed relationships. “That’s what’s crazy!”")]), _c('p', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("Cassidy visibly faltered. “He just acted so different. And he changed so fast….”")]), _c('p', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("Justin cleared his throat and waited for a go signal this time. “When someone’s internal life is extremely different from their external life, it seems like they change fast, but it’s not that simple. They’re actually revealing the real person they’ve been hiding for a long time.”")]), _c('p', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("Cassidy was still focused on the sex number. Something about it had lodged in her mind like a splinter, and she couldn’t stop squeezing and plucking at it. “It was so weird. This woman was saying these intimate sexual things, but it was in this half-singsong way, like she was talking to a child. It was…I don’t know what it was. It sounded like some sick sex lullaby. Then I thought about Steve and I just started screaming at her. Just screaming and screaming. I couldn’t stop. I don’t even know what I said, but it must have been pretty bad.” She laughed shakily. “She hung up, and I was paying her eight dollars a minute.”")]), _c('p', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("Trina, a teenaged prostitute who was there as part of her probation, made a scornful sound. “I didn’t even know people paid for phone sex anymore!” Despite the tough talk, Trina was so tiny that she had her feet up on the edge of her seat and her arms wrapped around her knees. She looked like a tight little fist. “Hello. It’s called internet porn?”")]), _c('p', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("Justin cleared his throat. “Let’s take the emphasis away from Steve for a while,” Justin said. “Let’s talk about you, Cassidy.”")]), _c('p', {
    attrs: {
      "id": "p24"
    }
  }, [_vm._v("Things kind of stalled after that. Cassidy ran out of gas, and Justin gave her a few things to think about before letting her retreat back into herself.")]), _c('p', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("When it was my turn to talk, I cleared my throat. “My name is John Charming. I know, it’s a weird name. The thing is, I come from a long line of monster hunters, and I came here tonight because I have a dead cop on my hands, and I really want to get rid of the body in a way that makes it look like he died in the line of duty. I figured meetings like these would be a good place to get a lead on some violent criminals who deserve to get framed for murdering a police officer.”")]), _c('p', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("Well, okay, I didn’t really say any of that. These people were traumatized enough. But that’s what I wanted to say. It was a support group, after all; it would have been nice to get some support.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration1"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("I volunteered to be the somebody who washed the ceramic cups and plates after the meeting disbanded. The deacon who showed up to close the church told me he would take care of it, but he said it in the perfunctory way of a person doing what’s socially expected of them, and he seemed grateful when I ignored him. “We’ve got Styrofoam cups and plates in the pantry, but that guy over there”—he indicated Justin with a nod—“said something about landfills.”")]), _c('p', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("I remained neutral. The basement had a little kitchenette walled off behind a huge counter, and I went ahead and filled one of the side-by-side sinks with soapy water. I could still smell the remnants of a lot of intense emotions in the air, and I like methodical, mindlessly repetitive tasks when I’m trying not to think too heavily about my past or my future.")]), _c('p', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("Cassidy came over to help me dry while some people put away folding chairs, others left, and a few hung around to talk to other members about something that had resonated. I had mumbled some vague story about being a cop who had quit the force after seeing too many bad things. All respectable enough, but Justin wasn’t going to let me walk off with Cassidy without saying something about it . I liked that about him.")]), _c('p', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("“He was buying her gifts too, wasn’t he?” I asked Cassidy quietly. “Steve.”")]), _c('p', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("She actually froze with the dishrag in her hand as if she were in a still frame. Then she tried to answer coldly, but her voice was shaky. “How’d you know that?”")]), _c('p', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("Because she’d mentioned that Steve broke into her house looking for a specific piece of jewelry, but what I said was “You’re the second person in Vista Verde I’ve heard talking about some phone sex operation that seemed a little hinky. A friend of mine who’s a cop said something about looking into something like that a couple of weeks ago. These phone sex operators were getting men convinced that they were really in love, and the men were sending the women all kinds of expensive gifts and things.”")]), _c('p', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("She bit the hook. “Steve was buying lots of jewelry and sending packages to some place that must have been pretty far away. The dumbass paid for the postage with my card. Or maybe he wasn’t dumb. I guess he just didn’t care anymore.”")]), _c('p', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("“Where was the phone number from?” I wondered.")]), _c('p', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("“I don’t know,” she said. “But I’ve heard about that kind of stuff online. People getting people to fall for them over the internet and then telling them they need money to get out of their country or something.”")]), _c('p', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("“But you feel like Steve is dead.”")]), _c('p', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("She hadn’t actually said that during the meeting, and she didn’t admit it now. A huge sob without tears shuddered through her. “He wasn’t some fake when I fell in love with him. He changed.”")]), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("“I believe you.” And I did.")]), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("“He was in so much debt. The police think he just ran away from it,” she said uncertainly.")]), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("I nodded. “But you think his obsession with this woman got him killed somehow.”")]), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("Cassidy still wouldn’t address that directly. Like saying it out loud might make it true. “He wasn’t even ashamed when I caught him breaking into my home! He was crazy! He was hitting me, but it was like he didn’t even see me. I don’t see how he could have kept on like that and not have something bad happen to him.”")]), _c('p', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("“I haven’t seen my police officer friend for a while,” I said. “But I could pass the number on to him if you’d like. See if it’s the same people.”")]), _c('p', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("“Everybody says I have to let it go.” She was just stalling. It didn’t matter how unlikely or unconvincing my story was. There was no way she wasn’t going to give me the number.")]), _c('p', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("“I’m not a psychologist,” I said. “But maybe this would be a good way for you to do that.”")]), _c('p', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("She still hesitated. “What about you? Aren’t you supposed to be getting over being a cop?”")]), _c('p', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("I half smiled. “I’d just be passing on some information.”")]), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("She sighed and recited the number as if I’d dropped a quarter in her ear. “Do you want something to write that down on?”")]), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("I repeated the number back to her, maybe showing off a little. “And if you got billed for postage, you can probably get the tracking number for some of those packages too.”")]), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("“I don’t know much about that kind of thing,” she said.")]), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("I handed over the last cup. “How about this? Why don’t you cut your credit card information and address off the billing statements? Bring them to me tomorrow morning at a public place, like that diner I saw on South Main Street. And definitely don’t let a strange man you met at a meeting for messed-up people come to your house.”")]), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("She gave me a small smile at that. “You’re the protective type, aren’t you?”")]), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("I shrugged uncomfortably.")]), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("“The real thing,” she said. “Not like those men who act like they want to take care of you, but they really just want to take over your life.”")]), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("“I have my own problems,” I said.")]), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("“I can see that.” Cassidy folded up her dish towel. “Like trying to warn women off because you don’t think you deserve to have anyone close to you.”")]), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("That crack had a little too much dirt in it. I don’t know what showed on my face, but Cassidy laughed. “Not my first therapy session.”")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration2"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("I was the last member of the meeting in the church parking lot, though the deacon was still puttering around inside. I stood beside my pickup truck and sighed. “Come on out, Samuel.”")]), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("Samuel Blanco emerged from the shadows of a small playground next to the church. He was eerily good at hiding in darkness, considering that he was six foot six and built like a dump truck. It was cold but he was dressed in a blue T-shirt and jeans, his dark hair swinging lankly around his broad shoulders. “Hey.”")]), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("“You were supposed to stay at the campsite,” I pointed out, though I was careful not to sound irritated. Samuel had a short fuse, but at least he came by it honestly. He was the child of an aatxe, half human and half fire elemental, and any kind of flame can get out of control quickly.")]), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("“There was nothing to do there,” he complained. Ever since I had helped Samuel quit his job and negotiate ending his rental agreement early, we had been camping in the mountains outside Vista Verde. Samuel liked to draw, and I had bought him a sketch pad and drawing supplies. He liked music, and I had bought a portable CD player—nothing that emitted a GPS signal—and batteries and several CDs. But I wasn’t surprised that Samuel wasn’t too good at self-entertaining without beer or television. I’m not any kind of mental health professional, but Samuel was intellectually disabled in some fashion. A low IQ, a short attention span, limited memory retention, some anger management issues, an inability to recognize complex facial expressions or tones, and a tendency to be over-literal all seemed to be part of whatever was going on with him. Not too different from a lot of people who manage to function in society, really, but Samuel had the added complication of a magical nature that he had to conceal.")]), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("What really bothered me was the question of how Samuel had tracked me. Some animals can home in on their family, pack, mate, or mother, but the idea that I was becoming any of those things to Samuel wasn’t exactly comforting. But my choices were to take responsibility for him, find him a home, or end him.")]), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("Samuel had killed the police officer whose death I was trying to make right.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration3"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("“Why are you crunching your face up like that? What’s wrong?” Samuel took a handball-sized scoop of ice cream from his fourth hot fudge sundae and shoveled it into his mouth.")]), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("“Dude, take small bites,” I said absently. I was frowning at the laptop I’d set up on the table between us. “Eat slowly. This isn’t about filling up. This is about enjoying the taste.”")]), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("“This is how I enjoy the taste.” Samuel was already troweling another fudge-covered vanilla lump into his maw. “What’s wrong?”")]), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("I looked around the truck stop. I actually feel safer in shadows than in brightly lit spaces surrounded by darkness. I felt like I was in an aquarium for people fish. “I can’t track the location of a phone number I got at the meeting.”")]), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("Samuel’s grin was huge, and it stayed on his face as if he’d left it there and forgotten about it. “Some girl gave you her phone number?”")]), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("I watched him tilt what was left of the sundae and drain it A stream of ice cream and chocolate syrup leaked down the corner of his mouth and over his chin. “It’s part of getting ready to leave this place.”")]), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("“Why do we have to?” Samuel asked. We’d had this conversation at least twenty times. What he was really saying was “I don’t want to.”")]), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("“You’re getting more of that sundae on you than in you, Samuel.” Was it wrong to treat him like a child? I had no idea, but I took the glass out of his hand and replaced it with more napkins. “You don’t get old, Samuel. Sooner or later, people will start to notice. It’s why your family used to move you around every ten or so years, right?”")]), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("“Lots of times,” Samuel said starkly. “I’m tired of it.”")]), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("From what I’d been able to gather, Samuel had been the Blanco family secret for at least a hundred years. His mother had gotten impregnated by a supernatural being in circumstances Samuel didn’t know or couldn’t process, and his Basque relatives had shuffled him around for generations.")]), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("“Besides, you killed some people,” I reminded him. I was willing to let the two vandals who had tried to stab Samuel lie, but I was determined to do right by the memory of the police officer he’d killed. Samuel rotated his jaw several times. “My mouth is cold!”")]), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("I couldn’t tell if Samuel was changing the subject because he was uncomfortable about the violence he’d committed or just easily distracted. “Maybe we should order you some soup.”")]), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("“I don’t want soup. I don’t want to wash the sweet out.” Samuel kept opening and shutting his mouth experimentally.")]), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("“Uhhhmmmmn.” My mind went back to the phone number problem. There are a depressingly large number of online services and stalker apps that will track down the personal information and current location of a cell phone number. Even more depressingly, I often use them. But I was starting to think the number Cassidy had given me was an unlisted landline. An old-fashioned private landline wouldn’t broadcast GPS coordinates, and its owner and location could be hidden behind a limited liability corporation license. Not impossible for anyone who wasn’t a law officer to track, but doing it with a laptop from a restaurant booth was beyond my limited technological savvy.")]), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("In a way, a landline made sense. Magic causes energy disruptions, and most modern wireless and digital technology is too sensitive to work around it. If the sex operator who had enticed Cassidy’s husband really was using some kind of spell or magical ability over the phone—and I thought she was—it was possible that she had to use a landline because a cell phone would keep shutting down the moment she started chanting or singing. But If the spell went into one landline receiver and came out a cell phone seven hundred miles away and still had a magical effect, why wouldn’t that magic still shut down the cell phone?")]), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("I started doodling something that looked like a ward stone surrounded by ley lines on a napkin. Lots of defensive magic functions by drawing and channeling magic into the ground where it can be dispersed by the earth’s magnetic field…Did the act of physically travelling through copper filament and being grounded before going through some kind of transmitting station dilute the magic just enough that it could still function but not shut down cell phones? Some men who called phone sex numbers were probably obsessive about it. Was it possible they were getting repeated doses of a small amount of magic, the effect of which grew stronger over time? I didn’t like the idea that someone was experimenting with those kinds of thresholds. The fact that most curses can’t be conveyed through technology is one of the few things keeping the world halfway stable.")]), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("While I was mulling this over, Samuel belched fire. It was a small flame, certainly not comparable to anything that a circus performer would do to draw attention, but it was real fire. I looked around—slowly, not frantically, because sudden motion draws attention—but there were only two other customers in the restaurant, and neither of them was very alert.")]), _c('p', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("“Samuel,” I didn’t have to speak loud. His hearing was as good as mine. “You can’t do things like breathe fire.”")]), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("An expression came into his eyes. Slightly guilty, somewhat chagrined, with both innocence and a sort of cunning lurking in there. “I didn’t.”")]), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("“I saw it. If you breathe fire in public, knights from my old order will find us and kill us both,” I explained.")]), _c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_vm._v("“I just burped.” He was challenging me.")]), _c('p', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("“You haven’t been burping flames your whole life or you would have been discovered by now. And if you keep breathing fire, someone will stop you no matter what your reason is. It might be me.” I let him see the part of me that would end the problem Samuel represented once and for all if I had to, just for a moment. I’m not proud of that part of me, but it’s real, and it’s there anytime I need it.")]), _c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_vm._v("The emotion crouching behind his eyes changed to something like panic. “No,” he mumbled. “It was an accident.”")]), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("I sighed. Now I felt like a bully. There was no easy balance to strike with Samuel. I was either protecting a killer or mishandling someone with disabilities and needs I had no idea how to deal with. Would killing Samuel be the hard choice that I had to make to protect other people, or would it be a sociopath’s way out?")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration4"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p91"
    }
  }, [_vm._v("The next morning, Cassidy gave me the number of a PO box in Porter, Alabama. “Getting the tracking number was easier than I thought,” she explained.")]), _c('p', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("I gave her an encouraging nod. “Good.”")]), _c('p', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("We were having pancakes at the Main Street Café even though she was cheating and having a salad instead. In fact, Cassidy was acting like we were on a date. She was wearing a black jacket open over a green dress that was somewhere between office job and nightclub. She smelled good. I was wearing a blue shirt from the Gap that I’d gotten from a Goodwill and smelled faintly of woodsmoke and Speed Stick. She had nervously offered her hand and her full name, something we hadn’t done at the meeting. “Cassidy Chalupnik.”")]), _c('p', {
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("I asked her a question to cover the fact that I wasn’t offering my full name back. Cassidy seemed like someone who would Google any name I gave her as soon as she had a moment with her smartphone, and I had a lot of names ready with bland histories and no pictures on the internet, but none of them matched the story I’d given at the meeting. “Chalupnik. Is that Polish?”")]), _c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("She laughed self-consciously. “It’s Czechoslovakian. I hate it. I wish I could keep Steve’s name, but, well, you know. It’s a shame though. I really liked being Cassidy Jameson.”")]), _c('p', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("“I like Chalupnik,” I said. “It has character. Like a good chunky soup.” I had no idea what I was talking about.")]), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("“It means "), _c('i', [_vm._v("peasant")]), _vm._v(",” she said a little dourly. “I have no idea why my family kept it.”\n         ")]), _c('p', {
    attrs: {
      "id": "p98"
    }
  }, [_vm._v("“So, why are you?” I asked.")]), _c('p', {
    attrs: {
      "id": "p99"
    }
  }, [_vm._v("She considered this. “Hmmm. I don’t know.”")]), _c('p', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("“Maybe that’s their reason too,” I said.")]), _c('p', {
    attrs: {
      "id": "p101"
    }
  }, [_vm._v("She got around to the thing I was trying to avoid. Women are good at that. “So, what’s your name?”")]), _c('p', {
    attrs: {
      "id": "p102"
    }
  }, [_vm._v("“O’ Toole.” I improvised. Between the huge number of Irish cops in Chicago, New York, and Boston, the chances of there being a lot of cops named Tom O’Toole seemed pretty good. “So, see? Your name’s not so bad. You could be a tool.”")]), _c('p', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("She laughed, mostly to be polite, and then our food got there and the conversation died for a while. I didn’t try to resurrect it. I don’t mind silence.")]), _c('p', {
    attrs: {
      "id": "p104"
    }
  }, [_vm._v("“What do you do for sex?” she asked abruptly.")]), _c('p', {
    attrs: {
      "id": "p105"
    }
  }, [_vm._v("It was an unusually frank question, but maybe it was because we’d met in a meeting where people were baring intimate details about their lives. I answered. “That’s not the real reason I wanted the phone number, if that’s what you’re wondering.”")]), _c('p', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("She laughed a little self-consciously. “No. I mean…how do you get it?”")]), _c('p', {
    attrs: {
      "id": "p107"
    }
  }, [_vm._v("“Usually, I run my eyes and hands and lips over the body of a woman who’s willing to have sex with me,” I explained. “This helps the woman lubricate and speeds up my heart rate, which sends blood rushing into my groin and causes a certain part of that area to expand…”")]), _c('p', {
    attrs: {
      "id": "p108"
    }
  }, [_vm._v("She crumpled up her napkin and threw it at me. It bounced off my chest and landed on the floor. “Shut up.”")]), _c('p', {
    attrs: {
      "id": "p109"
    }
  }, [_vm._v("“Honestly? There are women who aren’t looking for a serious relationship,” I said. It was true. Some of them were divorced and wanted to jumpstart their sex life again, or career-oriented, or widowed, or independent, or felt like they wanted to have fun and see what was out there before they settled down. “Every now and then, we bump into each other.”")]), _c('p', {
    attrs: {
      "id": "p110"
    }
  }, [_vm._v("“So to speak,” she said.")]), _c('p', {
    attrs: {
      "id": "p111"
    }
  }, [_vm._v("“So to speak,” I said. “What are you really asking me, Cassidy?”")]), _c('p', {
    attrs: {
      "id": "p112"
    }
  }, [_vm._v("“You’re some kind of gypsy right now, right?” She said.")]), _c('p', {
    attrs: {
      "id": "p113"
    }
  }, [_vm._v("“That’s a nice way of putting it,” I agreed. “Although it might piss off some gypsies.”")]), _c('p', {
    attrs: {
      "id": "p114"
    }
  }, [_vm._v("“And, well…everybody needs sex,” she forged on.")]), _c('p', {
    attrs: {
      "id": "p115"
    }
  }, [_vm._v("“Well, not like oxygen,” I said. “But yeah. One way or the other.”")]), _c('p', {
    attrs: {
      "id": "p116"
    }
  }, [_vm._v("“I’m not ready for anything serious either,” she said. “But I’m…well…It’s been a while. And I’m in a small town. I can’t just put on a sexy dress and go to a bar and wait for some hot stranger to come along or whatever they do in big cities. There’s only one bar that isn’t a dive around here, and even if I went there, most of the men are too dumb or too young or too mean or too married. And none of them would be strangers.”")]), _c('p', {
    attrs: {
      "id": "p117"
    }
  }, [_vm._v("“Sounds like you need a trank gun and a black van,” I observed.")]), _c('p', {
    attrs: {
      "id": "p118"
    }
  }, [_vm._v("“The next thing I throw is going to be my knife,” she warned.")]), _c('p', {
    attrs: {
      "id": "p119"
    }
  }, [_vm._v("I held up a palm in a gesture of apology. “Sorry.”")]), _c('p', {
    attrs: {
      "id": "p120"
    }
  }, [_vm._v("“I’ve thought about Match.com or eHarmony or some other dating site, but that just seems like a lot of BS that I’m not ready for,” she said. “I’ve thought about Craigslist or something like it too. I hear there are websites that have links for people who just want to skip all the hoo-hah and get to the…”")]), _c('p', {
    attrs: {
      "id": "p121"
    }
  }, [_vm._v("“Yee-hah?” I suggested.")]), _c('p', {
    attrs: {
      "id": "p122"
    }
  }, [_vm._v("She smiled a little self-consciously. “But then I think about Steve and I just can’t do it. I don’t want to be like him.”")]), _c('p', {
    attrs: {
      "id": "p123"
    }
  }, [_vm._v("“Ummhmmn,” I grunted for lack of anything better to say.")]), _c('p', {
    attrs: {
      "id": "p124"
    }
  }, [_vm._v("“Do you think I’m messed up?” she asked.")]), _c('p', {
    attrs: {
      "id": "p125"
    }
  }, [_vm._v("“Yes,” I responded.")]), _c('p', {
    attrs: {
      "id": "p126"
    }
  }, [_vm._v("“Thanks!” she shot back angrily.")]), _c('p', {
    attrs: {
      "id": "p127"
    }
  }, [_vm._v("“Come on,” I said mildly. “Everybody is.”")]), _c('p', {
    attrs: {
      "id": "p128"
    }
  }, [_vm._v("“Steve’s barely been gone for half a year. I guess he was gone before that, really, but….” She stuttered to a halt.")]), _c('p', {
    attrs: {
      "id": "p129"
    }
  }, [_vm._v("“We all have different ways of trying to deal with our crap.” I paused while a waitress came over and refilled my coffee. It was true enough. Some people suffer a loss and their libido goes up. Some people’s libido goes down. Some people want to find a cave to huddle in, and some people want company.")]), _c('p', {
    attrs: {
      "id": "p130"
    }
  }, [_vm._v("“So, you don’t think I’m a freak?” she said.")]), _c('p', {
    attrs: {
      "id": "p131"
    }
  }, [_vm._v("I didn’t explain how broad my definition of freakiness could get, up to and including tails, scales, stingers, fangs, claws, cannibalism, extra limbs, possession, and human sacrifice. Instead, I said, “I don’t care what anyone else does with their body as long as they’re not raping somebody or having sex with a minor. It’s none of my business.”")]), _c('p', {
    attrs: {
      "id": "p132"
    }
  }, [_vm._v("Cassidy wasn’t giving up that easily. “What if someone wants to make it your business?”")]), _c('p', {
    attrs: {
      "id": "p133"
    }
  }, [_vm._v("Look, I don’t go trolling around self-help groups looking for vulnerable women to sleep with, but I wasn’t sure how to put that tactfully. I tried anyhow. “I have rules. No married women. No women who are under the influence. No women in emotional crisis.”")]), _c('p', {
    attrs: {
      "id": "p134"
    }
  }, [_vm._v("Cassidy gave me a challenging look. “You think I’m in emotional crisis?”")]), _c('p', {
    attrs: {
      "id": "p135"
    }
  }, [_vm._v("“Well, I met you at a meeting for people with post-traumatic stress disorder,” I said. “That might be a clue.”")]), _c('p', {
    attrs: {
      "id": "p136"
    }
  }, [_vm._v("She snorted, half amused and half defensive. “You were there too.”")]), _c('p', {
    attrs: {
      "id": "p137"
    }
  }, [_vm._v("“I know,” I said. “Which is why you should be staying away from me. When we went there, it was with the understanding that we weren’t going to cross certain lines. That kind of thing matters to me.”")]), _c('p', {
    attrs: {
      "id": "p138"
    }
  }, [_vm._v("“Why?” she said.")]), _c('p', {
    attrs: {
      "id": "p139"
    }
  }, [_vm._v("Because a woman I loved died because she knew me, and I still kind of hate myself. But what I said was “It’s all I’ve got.”")]), _c('p', {
    attrs: {
      "id": "p140"
    }
  }, [_vm._v("She started to cry.")]), _c('p', {
    attrs: {
      "id": "p141"
    }
  }, [_vm._v("“Hey,” I protested mildly.")]), _c('p', {
    attrs: {
      "id": "p142"
    }
  }, [_vm._v("She shook her head, and I let her sob quietly while every person in the diner around us silently decided that I was an asshole. When Cassidy finally spoke again, she half laughed and dried her eyes. “Sorry. This just isn’t how I pictured the whole sexy drifter fantasy thing playing out.”")]), _c('p', {
    attrs: {
      "id": "p143"
    }
  }, [_vm._v("“I’m sorry too,” I said.")]), _c('p', {
    attrs: {
      "id": "p144"
    }
  }, [_vm._v("That was the wrong thing to say. Her self-esteem was in a fragile state, and when Cassidy pulled herself back together, it was as if she’d turned some kind of switch off. She spoke coldly and formally, like we were closing some kind of business deal. “If you find out anything about that number, I don’t want to know about it.”")]), _c('p', {
    attrs: {
      "id": "p145"
    }
  }, [_vm._v("“Okay,” I said.")]), _c('p', {
    attrs: {
      "id": "p146"
    }
  }, [_vm._v("“This is it.” She stood up. “I’m letting it go.”")]), _c('p', {
    attrs: {
      "id": "p147"
    }
  }, [_vm._v("“Okay,” I repeated, and she walked out of the diner without saying good-bye. That’s the thing about people who are barely coping with grief: whatever she was going through, it had never really been about me, and it shouldn’t have been.")]), _c('p', {
    attrs: {
      "id": "p148"
    }
  }, [_vm._v("I picked up the check.")]), _c('p', {
    attrs: {
      "id": "p149"
    }
  }, [_vm._v("I still don’t know if I should have picked up the Czech.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration5"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p150"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p151"
    }
  }, [_vm._v("I found a large gold pocket watch in a pawn shop in Martinsburg, and then a bench jeweler who was willing to take the watch apart and put it back together again. Tim McMillon was in his sixties and not radiating health. He had cheap fake teeth, big glasses, mottled skin, lots of soft fat, and a cough that didn’t sound temporary, but he still had standards. “What is it you want me to put in the watch, exactly?”")]), _c('p', {
    attrs: {
      "id": "p152"
    }
  }, [_vm._v("“A tiny tracking device made for dog collars.” I pulled one out of my pocket.")]), _c('p', {
    attrs: {
      "id": "p153"
    }
  }, [_vm._v("Tim took the tracker and examined it suspiciously. His business didn’t look like it was doing much better than he was—it was a grimy, cramped little store in a strip mall, and Tim was the only person in it—but I got the distinct impression that he still wasn’t going to help me if he thought I was stalking an ex-girlfriend. “Why do you want to put a GPS chip in a pocket watch?”")]), _c('p', {
    attrs: {
      "id": "p154"
    }
  }, [_vm._v("“Well, I keep losing track of time…” I began, but I stopped when his expression turned sour. It hadn’t been that sweet to begin with. I tried again. “I’m trying to track down a rare coin, and I think a pawn shop owner fenced it through some kind of black market. I want to use this gold watch to follow his pipeline.”")]), _c('p', {
    attrs: {
      "id": "p155"
    }
  }, [_vm._v("“You’re a police officer?” he asked doubtfully.")]), _c('p', {
    attrs: {
      "id": "p156"
    }
  }, [_vm._v("“God no, I’m a treasure hunter,” I said. “I think the coin came from a shipwreck off the coast of South Carolina.”")]), _c('p', {
    attrs: {
      "id": "p157"
    }
  }, [_vm._v("“Hmmm,” Tim said, and we were still working out the details when a shadow fell over us. Samuel had gotten bored in my truck and was standing directly outside the store’s front window, his face pressed too close to the pane. Samuel’s unnaturally hot breath had created a patch of fogged glass the size of a beach blanket, and his body was blurred and outlined in sunlight at the same time. Even in jeans and flannel, Samuel’s misty outline towered there like the sign of some kind of apocalypse, his features hidden.")]), _c('p', {
    attrs: {
      "id": "p158"
    }
  }, [_vm._v("“Jesus Christ!” Tim breathed.")]), _c('p', {
    attrs: {
      "id": "p159"
    }
  }, [_vm._v("“Not even close,” I assured him.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration6"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p160"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p161"
    }
  }, [_vm._v("While waiting for Tim to finish working on the watch, I took Samuel to a public library with a computer area. Samuel played some kind of video game where little animated stick figures kept getting blown up while he tried to navigate them out of a maze, and he seemed to enjoy it. He laughed so loud and so often that some of the other patrons got a little uncomfortable, but nobody was going to say anything to a six foot six behemoth who seemed to have some impulse-control issues. I sat next to him and spent the time researching Porter, Alabama.")]), _c('p', {
    attrs: {
      "id": "p162"
    }
  }, [_vm._v("Porter got its name back in the 1800s from a prominent family of shipping magnates who made their living off the Black Warrior River. Before that, the land had existed in various degrees of contention between Choctaw and Creek Native Americans. The area was also pretty close to Tuscaloosa, which used to be known as “The Druid City.”")]), _c('p', {
    attrs: {
      "id": "p163"
    }
  }, [_vm._v("Any one of those facts could have been significant.")]), _c('p', {
    attrs: {
      "id": "p164"
    }
  }, [_vm._v("The crime rate was pretty high in Porter, but so were the population density and the poverty index. I couldn’t find any references to notorious unsolved crimes or local legends or an unusual volume of mysterious disappearances or missing pets, at least not quickly. If I was dealing with a phone sex operation that ensnared victims from a distance, the people disappearing might not be locals anyhow.")]), _c('p', {
    attrs: {
      "id": "p165"
    }
  }, [_vm._v("I wasn’t going to figure out whatever was going on in Porter by staring at a computer screen.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration7"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p166"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p167"
    }
  }, [_vm._v("Samuel was waiting for me in my truck when I came out of the post office. So was the body of Jim Reedy, the dead police officer. The corpse was wrapped securely and tucked into a cargo container designed to go on the top of vehicles. The container was airtight, packed full of ice and salt, bungeed down in my pickup’s bed, and covered with a tarp, and I still didn’t like putting a decomposing body so close to my camping gear. But I didn’t want to come back to get the corpse later either.")]), _c('p', {
    attrs: {
      "id": "p168"
    }
  }, [_vm._v("“Let’s go,” I said.")]), _c('p', {
    attrs: {
      "id": "p169"
    }
  }, [_vm._v("“Where are we going?” Samuel asked grumpily.")]), _c('p', {
    attrs: {
      "id": "p170"
    }
  }, [_vm._v("“I just mailed a gold pocket watch to a PO box in Porter, Alabama,” I said. “We’re going to race it there.”")]), _c('p', {
    attrs: {
      "id": "p171"
    }
  }, [_vm._v("“Races are boring,” Samuel said. “People just go around and around in circles. Unless they crash and burn.”")]), _c('p', {
    attrs: {
      "id": "p172"
    }
  }, [_vm._v("I resisted any obvious metaphors.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration8"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p173"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p174"
    }
  }, [_vm._v("What I hadn’t accounted for was how scary leaving Vista Verde was for Samuel. If I had given us some leeway to travel over several days, stopping at long intervals, it probably would have been a lot better, but I made a mistake. I mailed the pocket watch priority mail, and it didn’t leave us much flex time. The thing was, Samuel didn’t have the vocabulary or the wiring to articulate all of the complex emotions he was struggling with, so he expressed himself by acting out and being a total nonstop pain in the ass. I mean, I know this is supposed to be some uplifting story where I learn something about myself and the song “We’re only human” plays in the background and everybody gets politically correct points and there’s a pat ending or something. But the truth is, the eleven-hour road trip that I spent confined in close quarters with Samuel turned into a seventeen-hour nightmare. For one thing, I have a sensitive sense of smell, and the truck cab got turned into a fart festival by Samuel’s adventures in fast food. Samuel also kept changing the radio stations and podcasts and audio books and CDs that I tried to occupy him with, and he was grumbling or snarling or whining the whole time. He didn’t want to talk and he didn’t want to be quiet, and somehow he managed to not do either.")]), _c('p', {
    attrs: {
      "id": "p175"
    }
  }, [_vm._v("The truth is, trying to do something good isn’t always inspiring, and it often doesn’t have obvious rewards. On the contrary, trying to do the right thing is frequently hard and frustrating, and it has a steep learning curve, and it’s very easy to get discouraged and feel bad about yourself and start doubting that you even know what the right thing is. If that weren’t true, everyone would do the right thing all of the time.")]), _c('p', {
    attrs: {
      "id": "p176"
    }
  }, [_vm._v("I mean, just look around.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration9"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p177"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p178"
    }
  }, [_vm._v("Porter was a small town divided by the Black Warrior River. On one side of the river was a main street made up of faded red brick buildings that were close to a hundred years old. On the other side of the river were a bunch of old warehouses and factories and converted sawmills that looked a bit neglected. Both sides of the river were surrounded by an outlying grid of residential neighborhoods, franchise restaurants, pawn shops, Christian bookstores, and strip malls. There weren’t a lot of woods around, and what wilderness there was existed in a thin flank along the river.")]), _c('p', {
    attrs: {
      "id": "p179"
    }
  }, [_vm._v("It was fall, and stepping out of the air-conditioned truck into the parking lot of the storage silo was still like walking into the breath from some gigantic dog’s mouth. My shirt was plastered to my torso within seconds, and a bug the size of a peanut dropped onto my arm and just stayed there, daring me to do something about it. I don’t know if the bug was sluggish with so much engorged blood or just couldn’t take living in Porter any longer. I flicked it off my arm, not wanting to crush something that obscene on my skin. There were no mountains around us, not even any big hills, and the temperature was close to a hundred degrees with no shade and no wind.")]), _c('p', {
    attrs: {
      "id": "p180"
    }
  }, [_vm._v("“Nice,” Samuel said happily, as he hopped out of the truck, taking in a breath of heavy, hot air that could have filled up a beach ball. He had perked up the moment I told him we were in Porter, going from inconsolable and angry to interested and excited in about five minutes, and I had no idea what had triggered the turning point. I had driven all night without being able to maintain a single coherent thought for more than ten seconds, and my nerves were so shattered that I didn’t know if I wanted to fall down on my knees and scream hallelujah or punch Samuel or break down and weep with relief.")]), _c('p', {
    attrs: {
      "id": "p181"
    }
  }, [_vm._v("So, I just grunted. “Mmm.”")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration10"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p182"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p183"
    }
  }, [_vm._v("Porter had a small post office, and its PO boxes weren’t open twenty-four hours a day. The lobby closed when the counter closed at five thirty. My package arrived, but nobody came to pick it up, so I had to make arrangements.")]), _c('p', {
    attrs: {
      "id": "p184"
    }
  }, [_vm._v("I found a thorn-laden strip of woods along the river where we could camp at night without being messed with, and a defunct grocery store near the post office that we could park behind during the day.")]), _c('p', {
    attrs: {
      "id": "p185"
    }
  }, [_vm._v("Relatively concealed between two large Dumpsters that no one had reclaimed yet, we were able to stay well within the GPS chip’s range without causing people to wonder why I was hanging around the post office for ten hours.")]), _c('p', {
    attrs: {
      "id": "p186"
    }
  }, [_vm._v("The only people who wandered by our parking spot during the day were some homeless people who were squatting inside the grocery store, and I’d brought some extra groceries as a kind of peace offering and unofficial rent. I didn’t really have to—the store’s unofficial tenants took one look at Samuel and decided to leave us alone anyway—but they would talk to people, cops maybe, or shelter attendants, or clinic workers, or missionaries, or other homeless who would talk to those people, and a little respect and goodwill didn’t hurt anybody.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration11"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p187"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p188"
    }
  }, [_vm._v("Nobody came to fetch the pocket watch from the PO box for the first few days, and I spent the evenings in Porter researching the town’s history and local events. I found an easy way to keep Samuel occupied for a few hours at a time so that I could sniff around discreetly by myself. He was very territorial and task-oriented, and I told him to guard our tents and tell any cops who showed up to wait for me. It was all about the emphasis. If I had told Samuel to wait, he wouldn’t have. But he wasn’t going to leave our stuff vulnerable, and he sat sentry duty with an intent expression and no sign of impatience, drawing on his sketch pads. I felt a little ashamed. Samuel wanted to count and be included the same as anyone; he just didn’t have the tools to make that clear.")]), _c('p', {
    attrs: {
      "id": "p189"
    }
  }, [_vm._v("I tried the library, a couple of local hangouts, and a visitor’s center, but I wanted to talk to some longtime residents of Porter, and actually came across a clue at an assisted-living complex. I told the front desk clerk, a pleasant and plump brunette named Joan, that I was looking for a place for my autistic brother, and she assured me that younger people with disabilities lived there as well as senior citizens. I think she was being careful of my dignity because I was dressed casually in a T-shirt and jeans, and she wasn’t sure I could afford the place. Joan was a class act.")]), _c('p', {
    attrs: {
      "id": "p190"
    }
  }, [_vm._v("People were coming and going from some kind of movie in a community hall, and I asked Joan if I could speak to one of the residents for a few minutes. She hesitated for a moment, but then she saw an older gentleman walking by and cheerfully waved him over and agreed that I could talk to RJ as long as we stayed in the lobby.")]), _c('p', {
    attrs: {
      "id": "p191"
    }
  }, [_vm._v("RJ and I sat down in some wicker chairs, and after a few moments, I knew why Joan had agreed. RJ Quesenberry was lonely and loved to talk. I asked a few pro forma questions about the residence, but it didn’t take long to lead in to the town of Porter itself, and once I got RJ started, he was off.")]), _c('p', {
    attrs: {
      "id": "p192"
    }
  }, [_vm._v("“Oh, yeah, the Porters who started this town were from Greece,” RJ said in response to one of the questions I managed to interject. “They were in the shipping business.”")]), _c('p', {
    attrs: {
      "id": "p193"
    }
  }, [_vm._v("“Greeks named Porter?” I said skeptically.")]), _c('p', {
    attrs: {
      "id": "p194"
    }
  }, [_vm._v("He laughed. “I think their original name was Petropoulos. They changed it during World War II. The Greeks sided with the Nazis, you know.” He said that like he didn’t really expect me to know. I didn’t take it personally. I looked like I was in my late twenties, and somewhere in the past two or three decades, Americans stopped learning history.")]), _c('p', {
    attrs: {
      "id": "p195"
    }
  }, [_vm._v("“The name comes from Petro,” I offered. “Peter. Maybe the Porter family went Christian way back.”")]), _c('p', {
    attrs: {
      "id": "p196"
    }
  }, [_vm._v("“Huh,” RJ said. “Maybe so. I’m pretty sure their family moved on or died out back when I was a boy.”")]), _c('p', {
    attrs: {
      "id": "p197"
    }
  }, [_vm._v("“How about that?” I said it absentmindedly, but my brain was humming like a power line. I was pretty sure that the second half of the name, "), _c('i', [_vm._v("poulous")]), _vm._v(", meant chicken, as in "), _c('i', [_vm._v("pullus")]), _vm._v(" for nesting chick or poultry. And as soon as I had that thought, a lot of things began to fall into place. That’s what it’s like when you’re investigating—and it really doesn’t matter what you’re investigating—sometimes answers gradually take shape as the result of careful, methodical research, and sometimes some random fact will come out of nowhere, and all of these details that were right in front of you the whole time will start coming at you in an avalanche.\n         ")]), _c('p', {
    attrs: {
      "id": "p198"
    }
  }, [_vm._v("When Cassidy described the voice she’d heard over the phone as a kind of singsong lullaby, I thought she was describing a ritual incantation, and because of that erroneous assumption, I overlooked some obvious things. But now all of the clues were aligning. Greek. Hypnotic voice. Female. Nesting chick. Sexually enticing men to their doom.")]), _c('p', {
    attrs: {
      "id": "p199"
    }
  }, [_vm._v("I was hunting a siren.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration12"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p200"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p201"
    }
  }, [_vm._v("A lot of people have gotten sirens confused with mermaids, but here’s the thing: In the original stories, sirens were land creatures whose upper half was human and beautiful, while their lower half was all feathers and horribly destructive claws. These sirens—most famously in "), _c('i', [_vm._v("The Odyssey")]), _vm._v("—would hide their lower halves behind rocks and cause ships to crash on the crags by singing beautiful songs that drove sailors mad with lust. Then the sirens would leap down among the wreckage and tear the sailors apart with their claws.\n         ")]), _c('p', {
    attrs: {
      "id": "p202"
    }
  }, [_vm._v("Mermaids, on the other hand, were half-human, half-fish women, and merfolk were harmless for the most part. There are different tribes and cultures among the merfolk just like there are among humans, though, and occasionally mermaids would act as bait. They would show their naked human half to fishermen on the shore and pretend to be in trouble, and the fishermen would take a boat out to help the “drowning” mermaid, and then some opportunistic band of mer-sociopaths would swarm up out of the water and turn the boat over for fresh meat and shiny objects. There must have been a particularly vicious tribe or bandit culture among merfolk around the British isles, because in that region, mermaids were considered evil omens of death and destruction.")]), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("Then the Danish author Hans Christian Andersen came along and wrote a story about a mermaid—a perfectly nice young woman, by the way—who traded her beautiful singing voice to a witch in exchange for the ability to come on shore, and somehow the mermaid and siren storytelling traditions got confused and mixed together until the two terms became virtually indistinguishable.")]), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("But that’s a classic case of not getting stories straight. Sirens and mermaids? Apples and oranges. Chicken and fish.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration13"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("The gold watch started moving on the fourth morning after we arrived. It appeared as a dot on a four-by-four-inch digital satellite map that was plugged into my truck’s power port and suction-cupped to my windshield. I wasn’t too worried about how the setup looked—there are still people whose GPS systems aren’t built into their phones or dashboard, though they are becoming rarer by the week.")]), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("“Come on, Samuel,” I called out the pickup truck’s window. I packed up our tents every morning before the post office opened, so he was entertaining himself out in our strip of woods by doing something that caused snorting sounds. Which was odd, because he was in human form. I didn’t have to speak loudly though, and something in the tone of my voice must have triggered some hunter or defender’s instinct in Samuel, because he was there almost instantly even if he was covered in mud.")]), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("“What were you doing?” I asked.")]), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("“Smelling,” he said.")]), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("“You sure were.” I wrinkled my nose, and as literal as Samuel was, he got that one. He laughed loudly. I don’t know if he was being theatrical or unselfconscious, but he laughed in a way that most people don’t, full out and almost pronouncing the laughs as words.")]), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("“Come on and get in the truck.” I was smiling in spite of myself. “We’ve got to go.”")]), _c('p', {
    attrs: {
      "id": "p212"
    }
  }, [_vm._v("I didn’t want to risk getting stopped for speeding, so it took at least ten minutes to get close enough to the vehicle transporting the gold pocket watch to get a good look. It was a red Jeep, new but covered with mud, and the black nylon fabric top could be unzipped or unsnapped but was still on despite the heat. All I could tell about the driver was that she was female, with long black hair and smooth brown shoulders.")]), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("“Why are we—” Samuel started.")]), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("“Be quiet!” I snapped, just like a frustrated parent in line at a supermarket, and Samuel lapsed into a sullen silence. As soon as I had the chance, I went ahead and turned off on a side street, then circled back to follow the Jeep out of its line of sight. “I told you not to talk about what we were doing, remember? We’re chasing something that can hear really well.”")]), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("Actually, I didn’t know if the thing we were chasing could hear really well or not, but I didn’t want to complicate Samuel’s decision-making process with maybes.")]), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“Why?” If I sounded like a parent, Samuel sounded like a six-year-old, albeit a deep-voiced six-year-old who cast enough shade for a small family to picnic in.")]), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("“Because I’m pretty sure it’s killing a lot of people,” I explained.")]), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("“I killed some people.” I couldn’t hear any emotion in Samuel’s voice. Not fear. Not anger. Not shame. It was there. I just couldn’t hear it. “You didn’t kill me.”")]), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("“You killed some people you shouldn’t have,” I acknowledged. “But they were sort of threatening you, and I think you got confused. You’re going to stop killing people, right?”")]), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("“Aren’t you going to kill this person?” Sam wondered.")]), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_vm._v("“I…” How the hell was I supposed to answer that? “I’m not sure this is a person, Samuel. It only looks like a person.”")]), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("“I only look like a person too,” Samuel observed. “So do you.”")]), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("Oh, for…He had to start displaying surprisingly developed intellectual curiosity and reasoning skills "), _c('i', [_vm._v("now")]), _vm._v("? “I think this thing kills good people, Samuel. It’s mean. Do you know what hypnotism is?”\n         ")]), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("Samuel swayed his head back and forth and widened his eyes, letting his mouth hang open slackly. “Uuuuhhhhhh. I’m hypnotized.”")]), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("“Right,” I said. “This thing can hypnotize people. They aren’t hurting her or anything, and she makes them love her and trust her, and then she takes their money and kills them.”")]), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("Samuel didn’t say anything for a long time. Finally, he said. “So, I should kill "), _c('i', [_vm._v("her")]), _vm._v(".”\n         ")]), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("“If she tries to kill you, yes,” I said. “Don’t let her hurt you.”")]), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("“I won’t,” Samuel said, and something dark and mature came into his voice that made me believe him.")]), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("We had been traveling outside Porter proper for most of this conversation. The paved roads became dirt and gravel, and the residential homes became scarcer and older and less well maintained. Stores disappeared altogether except for the occasional gas station, and then the houses turned into trailers or old, faded brown barns with missing boards that hadn’t held livestock in a couple of decades.")]), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("Suddenly, the satellite map turned off. It might have just been that I wasn’t getting a signal any longer, but I didn’t think so. It was energy-sensitive technology, and I had a feeling magic was in the area. If I’d had a cell phone, I might have taken it out to see if it was messed up too, but I’m still hoping cell phones are just a fad.")]), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("Most magic doesn’t have that big a radius of effect, so I turned the truck around and drove a ways until I found an old trail that was chained off and had a peeling "), _c('span', {
    staticClass: "smallcaps-rw",
    staticStyle: {
      "font-size": "82%"
    }
  }, [_vm._v("NO TRESPASSING")]), _vm._v(" sign posted near it. The lock linking two ends of a chain was rusted shut. Most likely abandoned family land that someone had some vague idea of selling if real estate developers ever made it this far out. I yanked one of the wooden posts that the chain was threaded through back and forth until I dislodged it from the earth. No cars came along, but then, that was probably one of the reasons a supernatural predator would choose the area. I pulled my truck up the trail, parked it, got out, and went back and replanted the wooden post again.\n         ")]), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("“Come here, Samuel,” I said, fishing in my pocket.")]), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("“What?” he said a little distrustfully. Samuel had followed me out of the truck but was keeping his distance, picking up on how tension and adrenaline had changed my smell.")]), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("“I have some earplugs. I don’t want this thing hypnotizing you with its voice,” I said. They were good earplugs too, foam inserts that started expanding five seconds after being exposed to air. They would seal up an ear canal tighter than a steel weld. Which is why I took care to give Samuel some last instructions before removing the earplugs from their airtight wrapper. “You’re my secret weapon, Samuel. Just follow me and don’t make any noise, okay? If anyone attacks me, get them.”")]), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("“Someone wants to kill you?” There was a note of panic in his voice that hadn’t been there before. I hope it’s a mark of how intently I focus on a hunt or how long I’d been travelling alone that it wasn’t until then that I wondered what would happen to Samuel if I died. I wasn’t used to worrying about dying all that much. I can’t say I liked it.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration14"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("I picked up the weird scent within two hundred yards of the pickup truck. It was thick and slightly sour and somewhat avian. Birds might look great when they’re flying, but there’s a reason "), _c('i', [_vm._v("foul")]), _vm._v(" and "), _c('i', [_vm._v("fowl")]), _vm._v(" are homonyms. I’m just saying. It wasn’t a normal scent trail though. I would pick up a scent, lose it, and pick it up again ten or thirty feet later. Maybe the thing I was chasing hopped or fluttered. Then I picked up another similar but unique scent following the same irregular pattern, and then another. So maybe the "), _c('i', [_vm._v("three")]), _vm._v(" things I was chasing hopped or fluttered. Come to think of it, sirens often hung out in groups in the old stories, and these specimens left large three-clawed marks in the soil when they did so. If I didn’t know better, I would have thought I was tracking some land birds the size of ostriches.\n         ")]), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("At least sirens didn’t have any special immunities or regenerative capabilities, not that I knew of, so I was carrying a plain old double-barreled crossbow. I also had a katana sheathed between my shoulder blades, a Ruger Blackhawk holstered at my right hip, a small hip quiver with six quarrels on my left, and some really harsh language on the tip of my tongue. If none of that worked, I still had my most reliable weapon, a silver steel knife sheathed on the side of my combat boot.")]), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("The birds in the vicinity went quiet as I moved through the woods, and I was afraid sirens might pay particular attention to the sound of birds, but there was nothing I could do about it. If I’d been on my own, I might have stayed still at the outer perimeter for hours until the local wildlife had a chance to acclimate to my presence, but there was no way Samuel was going to be able to sit still that long, so I just kept shadowing the road.")]), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("Soon, I saw a place where a graveled trail branched off, and when I stepped back out onto what passed for a highway, I saw fresh tracks where a Jeep had recently turned. It looked like a rural driveway to me, and I followed it for about half a mile before I smelled something else worrisome: the faint trace scent of a decomposing body long dead and buried.")]), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("This is something most people don’t ever have to think about: A corpse buried underground will break down over time and provide nitrogen that soil desperately needs to feed plant life. This creates weird air pockets in the ground as gases expand, causing small fissures as the stuff tries to work its way up through the dirt. There is also downward movement as the roots of plants extend into the area where the enriched soil and the body are intermingling, creating more slight crevices and cracks. When the roots and the gas pockets connect, the plant releases more faint chemical traces into the atmosphere than just carbon dioxide. It’s one of the reasons corpse-sniffing dogs are still effective long after the physical trace smells have been washed off of the surface of ground concealing a buried body.")]), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("The other subtle sign of a buried body is a visible one. When the tree cover is thick enough to prevent much sun from getting through, and the surrounding ground is mostly bare of vegetation, plants above a buried body will get more nutrients than other plants in its vicinity. So, when I picked up the faint whiff of decomposition, I stopped and looked around and saw it…a nearby patch of ground where the sun-starved plant life was noticeably more verdant.")]), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("That wasn’t what creeped me out though.")]), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("It was the second patch of dirt that had unusually abundant forest growth. I saw it clearly now that I was looking for it, some twenty feet away. And the third patch of flourishing dirt. And the fourth. And the fifth. As I looked around, I saw at least thirty similar sites stretching off into the woods on all sides of me. No wonder I was picking up death smell. I was standing in the middle of an improvised cemetery.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration15"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p245"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("Eventually, the driveway fed into what looked like a dried-out basin. There were no other houses around, no other roads, just a long circular clearing, the red Jeep parked next to twelve other vehicles. That was where I saw a home in those woods that was as strange as any castle or gingerbread house could have been. Seven large mobile homes had been parked next to each other to make one large dwelling, forming a strange, uneven shape with the ends of different-colored trailers sticking out at varying lengths, probably because doors had been stationed next to each other so that they would adjoin. Had the trailers been welded together, or were there little wooden walkways or canvas walls built between the doors so that people could go from trailer to trailer as if moving through the rooms of one large house?")]), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("I couldn’t figure it out at first. For as much money as all those trailers must have cost combined, why not just build a home? Or for that matter, if somebody wanted to put trailers together like Lego blocks to build a bigger structure, why not at least buy trailers that were the same model or color so that they would stack together neatly and form a more uniform structure? But then something occurred to me that left me cold. The sirens were attracting their prey from a distance, and these were mobile homes. Emphasis on "), _c('i', [_vm._v("mobile")]), _vm._v(". Maybe their owners had been enticed into transporting their houses here, then killed so that the homes could be put to use by monsters who liked the location and didn’t want to leave a paper trail or have a bunch of construction workers hanging around for long periods of time.\n         ")]), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("There’s a word for ungainly homes pieced together from makeshift components. I was looking at a giant nest.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration16"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("The shirtless young man who came out of the nest carrying a toolbox was wearing a collar. I watched him through a pair of collapsible field glasses, and I could tell that it wasn’t a metal collar like slaves used to wear or a Viking torque. It was more like something you’d see in an S&M club except for the black box built into it: a shock collar, probably one designed for really large dogs. Its wireless technology wouldn’t work while any sirens were singing for the same reason that my tracking device wouldn’t work, but the sirens wouldn’t want to sing twenty-four hours a day, and the man wouldn’t run away while their magic was in effect. If he ran away at all. I’ve seen captives before, and this man didn’t move like a prisoner or a slave. His body was sleek and well muscled and well fed, with that smooth, long-haired, vaguely androgynous look common to models. He moved like someone who was at home. When he reached the red Jeep, the man opened the hood and began to examine the engine.")]), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("Maybe the woman or thing driving it had reported some kind of problem.")]), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("This seemed confirmed when a dusky-skinned, black-haired female came out of the trailer after him. She was beautiful, with classic Mediterranean features and sleek, strong arms and a trim waist that flowed into strong, curving hips. I couldn’t see her legs; she was wearing a long sundress that went down to her ankles and fashionable-looking boots whose thick high heels didn’t really go with the terrain. I pictured the tracks I’d seen and imagined clawed feet stretched out within those boots, the front talons extended through the body, the back talons driven through those wide high heels. It might have been true. There was something slightly odd about her gait, but only if you really looked for it, a slight pause between each step as one of her boots briefly disappeared up into the dress, and then she would glide smoothly over the ground when the boot came down again. I wondered if her knees were joined oddly.")]), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("The woman leaned over the man as he looked over the Jeep’s engine, maybe companionably, maybe with a proprietary attitude. It was hard to say. She reached over and ruffled his hair affectionately. I thought her attitude was more like a pet owner than a lover, but maybe my attitude was biased by the collar he was wearing.")]), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("I wasn’t clear on what happened to a man who was repeatedly exposed to the effects of a siren song over long periods of time. Was it like being heavily and constantly drugged? Could he be trained or conditioned, or form an addiction to the song, if he wasn’t killed? According to Cassidy Chalupnik, her husband, Steve, had become increasingly erratic and desperate to hear the song again over time.")]), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("A sudden thought occurred to me, and I moved my field glasses over the license plates of the other eleven vehicles. They were all new, most of them expensive sport-utility vehicles, and their license plates were from all over. Maine. Wisconsin. California. Vermont. The closest one was from Georgia. The former vehicles of men buried out in the woods, most likely. Were the sirens keeping the best cars they acquired as toys or just using the clearing as a car lot while they parceled cars out to chop shops for extra income?")]), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("I was still thinking about that when I heard singing coming from somewhere behind me. It didn’t sound abnormally beautiful, but it wasn’t as annoying as I find those wailing soprano solos from big, formal choirs either. The siren I was watching through my field glasses straightened up from over the hood of the red Jeep when she heard it too, but she didn’t seem unduly alarmed. Well, neither was I. Knights can’t be tranced because we’re already bound by a geas, a magical oath to keep the supernatural world hidden whatever the costs.")]), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("But the siren behind me didn’t know I was a knight. Ok, ex-knight. Whatever. So, I let the crossbow hang loosely at my side and turned around slowly, letting my features loosen. I had a sudden mental image of Samuel going slack-jawed and saying, “Uhhhhh I’m hypnotized,” and bizarrely, I almost cracked a smile. But when I saw the siren, I didn’t feel like smiling at all.")]), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("She was maybe fifteen yards away, squatting up on a tree limb some thirty feet above the ground. I think the siren must have been sitting up there unnaturally still the whole time—watching me, maybe alerted to my approach by the birds around her. She was shorter than the other siren I’d seen, maybe five foot three, but she had the same classic features, black hair, dusky skin, and strong, smooth arms and shoulders. Unlike her sister, this siren was wearing a white tank top and blue shorts. The feathers from her legs had been plucked, and even from that distance, I could tell that the skin was goose-fleshed, no pun intended. Her thighs were muscular and unnaturally thick in proportion to the rest of her body, her calves swelled, and her legs ended in long, gnarled, orangish-yellow claws that gripped the tree limb beneath her the way a parrot’s claws grip a swing bar. Her jaw may have been hinged a little differently too. It seemed like her mouth was open a little more wider than a normal human’s, her song louder as her head tilted back to create a straight passage from her lungs through her throat.")]), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("I began to walk toward her, and the siren dropped to the ground effortlessly, landing in a slight crouch as those supernaturally strong thighs absorbed the impact without any sign of strain. She kept singing the entire time, and I kept walking toward her, but I guess my zombie shuffle didn’t really resemble the way men really moved under the effects of her song. Or maybe she actually formed some kind of psychic connection with her victims, and she wasn’t getting any telepathic feedback from me. It was the reason I’d never risked calling the sex line. Whatever the cause, she sensed something was wrong and stopped singing and started screaming.")]), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("The scream didn’t sound human. It didn’t sound birdlike either. It was some weird hybrid sound. More worryingly, I heard an answering cry from the clearing behind me, and then another.")]), _c('p', {
    attrs: {
      "id": "p261"
    }
  }, [_vm._v("Well, at least she didn’t want to talk. I hate it when monsters want to talk.")]), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("I brought my crossbow up, but the siren bounded forward and covered the distance between us in two freakishly fast hop-and-skips. When I fired a crossbow bolt straight at her center mass, one of her feet kicked up and actually grabbed the short missile out of the air from six feet away. Fortunately, it slowed her down, and birdlike or not, the other foot was holding her up when I released the second bolt; it took her about an inch above her heart, puncturing the top of a lung if her anatomy went that way. Her body crashed into mine and knocked the crossbow out of my hand, but I kept my balance. Close up, I shifted to the side and caught the leg that was coming up before her knee could drive into me. I brought my hand up under her calf and lifted her body up off the ground, parallel to mine. She was lighter than she should have been—maybe her bones were hollow and more flexible than a human’s—and those clawed feet had no solid surface to push off against. She squawked and brought her right hand up to my face. Her fingernails were long and thick and sharp and scored trails up my cheek while she scrabbled for my eyes, but those claws stopped moving when I dropped and brought her back down on the sharp point of my knee. However her bones differed from mine, she had a spine, and it snapped.")]), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("I dropped her while she was still yelling, rising and whirling around, reaching for the katana sheathed between my shoulders. Her sister was screaming behind me and coming in fast, and thank God the sister had paused to take off her boots, because I needed that extra three seconds. If the art of the fast draw weren’t so integral to the katana, I wouldn’t have made it. The sister came bounding at me in a kind of untrained but instinctive front kick—damn, these things moved fast! The claws of her right foot were extended and pointed in a kind of pincerlike formation that would seize my throat and tear it out.")]), _c('p', {
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("Instead, I brought my katana around in a strike that mostly severed her foot. It would have removed the foot completely, but I didn’t have time to fully bring my hips into play, and whatever the claw was made of was insanely gnarled and hard. She screamed. The second siren’s right claw and my katana both went flying, and her body crashed past me at a side angle that sent both of us to the ground.")]), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("I rolled to my feet. She anchored her good claw in the ground, pulled her entire body upright in a way that no human could have accomplished, and grabbed at me with clawed hands before I could increase the distance between us. That should have been fine; her lower half was much stronger than mine, but her upper half was slightly weaker. I blocked her hands at the forearms and hit her in the face with short jabs, once, twice, three times before driving in a punch that would have snapped her neck if her bones really weren’t lighter and more flexible than mine.")]), _c('p', {
    attrs: {
      "id": "p305"
    }
  }, [_vm._v("I was controlling the situation until the siren whose back I’d snapped reached up from the ground and drove her fingernails into my right calf. I screamed myself and buckled slightly, twisting inside the older sister’s reach and wrapping my right arm around her neck to hold myself up. Even without a right foot, she brought her right knee up in a strike that shattered at least three of my ribs through the Kevlar vest I was wearing. I went with it, twisted my body in the direction her knee was driving me, and used my weight to snap her neck.")]), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("I fell when the older siren who was holding me up fell. The younger sister on the ground hadn’t been idle, and her nails actually severed my Achilles tendon, but I managed to catch my descent on my knees, and when my left hand came up from my hip, it was holding one of the crossbow quarrels. Kneeling, I drove the quarrel through the younger siren’s eye while she was flopping on the ground and trying to drive her claws through the Kevlar vest to disembowel me.")]), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("That’s when a rifle shot knocked me on my ass. The third sister was carrying a 700 Remington, though I didn’t know it at the time, and thank God she’d fired at center mass. It put me down, but the Kevlar kept my heart from being torn out. I stayed flat on the ground, a harder target while my somewhat numb fingers fumbled to unholster my Ruger Blackhawk. Another shot tore into the ground right in front of my upper left thigh, and I rolled behind a tree.")]), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("I needn’t have bothered. Between the singing and screaming and shooting, Samuel’d had all the cover he needed. The siren was fifty yards away, but I still saw it clearly when Samuel came out of nowhere, half human and half bull. Horns had emerged from his head, black fur was covering his body, and I don’t think I was imagining the flames licking behind him when he charged. The siren heard him at the last moment, dropped the rifle, and tried to bound out of the way, but he caught her as she left the ground and carried her forward with bone-crushing impact.")]), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("The Ruger Blackhawk was free at this point, and I rolled on to my stomach and trained my gun in the direction of the clearing. I could hear other sounds approaching, human sounds, some male and some female. I didn’t know how many lovers, servants, or slaves the sirens had in that compound, but the yells I heard didn’t sound like jubilant people taking their chance to claim freedom. They sounded like an angry mob.")]), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("I didn’t have to fire. By the time my Achilles tendon was healed, Samuel had finished with them.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration17"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p311"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("The trailers were full of swag. Jewelry, mostly, diamonds and emeralds and sapphires and rubies set into rings and necklaces and bracelets and earrings. The stuff was used as decoration, hanging from the walls and ceilings like Christmas tree lights, set on shelves like knickknacks, draped around lampshades and the bases of candles. I’ve had some practice gauging such things, and even at pawn or black market rates, I thought I could get at least two million dollars from the booty eventually, though half of any gain would be Samuel’s. I would probably keep the stuff in a storage silo for a couple of years in case it needed to cool off too.")]), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("I really, really hoped the place was as secluded as it seemed, what with all of the screaming and the rifle shots. It was going to take time to dispose of the sirens’ bodies, bury the deputy that Samuel had killed among all the other victims, and use the human bodies of the siren’s crew to frame a narrative. There had been three human females and five human males in the mix, and if I was reading the signs and bed smells right, three of the human females had been one of the sirens’ lovers and the males had been divided between the other two.")]), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("I thought I could make it look like the females and maybe some of the males had been running the phone sex operation as a way of luring victims to them. The hard part was going to be figuring out how to tip off the FBI and making the bodies that Samuel had broken and burned look like part of some kind of natural occurrence. Maybe I could make it look like a gunfight had occurred—fire bullets into some of the corpses, then set the trailers with the bodies inside them on fire as if someone was trying to destroy forensic evidence. Maybe leave some kind of gang tag to suggest a raid by a gang or cartel that the operation had refused to work for…or perhaps I could make it look like this crew had finally killed a victim with mob connections, or someone with a brother in the military. Whatever. I could work it out. A fire would actually be a great way to draw in authorities too. I could just report smoke instead of giving the FBI some covert tip-off. Authorities would search the surrounding woods when they found the bodies in the trailers and matched the cars’ license plates to missing victims. Someone would find the bodies eventually, including Jim Reedy’s.")]), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("And when the authorities contacted Cassie about Steve Jameson, she would talk about me, and my story about having a police friend from Vista Verde who had been checking out some hinky phone sex operation. Things wouldn’t make sense, but they would fall together all the same. The truth is, law enforcement types never have all the facts, and nothing ever completely makes sense. They try to piece together a story, and once they choose a plot, they let the story determine how they fill in the gaps. Some law agencies might come looking for me anyway, but I didn’t think they’d look too hard, and I was used to staying off the grid. My name and appearance and location would all have changed by the time they got around to it.")]), _c('p', {
    attrs: {
      "id": "p316"
    }
  }, [_vm._v("I could make it work. I just needed a few days.")]), _c('p', {
    attrs: {
      "id": "p317"
    }
  }, [_vm._v("I got them.")]), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration18"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p318"
    }
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p319"
    }
  }, [_vm._v("“Why do we have to keep moving all the time?” Samuel complained. “And why couldn’t we keep the truck? This Jeep stinks.”")]), _c('p', {
    attrs: {
      "id": "p320"
    }
  }, [_vm._v("We were driving the red Jeep to anywhere but Porter, only it was blue now. It turned out that the license plates on the vehicles weren’t legit—they were license plates that had been made by shearing multiple license plates in two and then welding them back together in different combinations. You couldn’t see the weld until you examined the license plates up close. I had removed all of the license plates from all the vehicles and was keeping them in a stack. The law enforcement agencies would still be able to trace the vehicles back to their owners through serial numbers, and the license plates might come in handy. “We won’t keep it long,” I said. “Just long enough to find you a new home.”")]), _c('p', {
    attrs: {
      "id": "p321"
    }
  }, [_vm._v("“What home?” Samuel demanded.")]), _c('p', {
    attrs: {
      "id": "p322"
    }
  }, [_vm._v("Well, that was the question, wasn’t it?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c354dfd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s003-Chapter-001.vue
// module id = 66
// module chunks = 0